import { BasePerson, BasePrincipal, PoaItem } from '../models'

export const getPrincipalsOrganizationNames = (proxy: PoaItem): string => {
  return (
    proxy?.principals
      ?.map((item: BasePrincipal) => {
        return item?.name || '—'
      })
      .join(', ') || '—'
  )
}

export const getPrincipalsManagerFullNames = (proxy: PoaItem): string => {
  return (
    proxy?.principals
      ?.map((item: BasePrincipal) => {
        return (
          [item.manager?.surname, item.manager?.name, item.manager?.middlename]
            .filter(Boolean)
            .join(' ') || '—'
        )
      })
      .join(', ') || '—'
  )
}

export const getRepresentativesFullNames = (proxy: PoaItem): string => {
  return (
    proxy?.representatives
      ?.map(
        (item: BasePerson) =>
          [item.surname, item.name, item.middlename]
            .filter(Boolean)
            .join(' ') || '—',
      )
      .join(', ') || '—'
  )
}

export const getPrincipalsManagerHalfNames = (proxy: PoaItem): string => {
  return (
    proxy?.principals
      ?.map((item: BasePrincipal) => {
        return (
          [item?.manager?.surname, item?.manager?.name]
            .filter(Boolean)
            .join(' ') || '—'
        )
      })
      .join(', ') || '—'
  )
}

export const getPrincipalsOrganizationNamesWithInnAndKpp = (
  proxy: PoaItem,
): string => {
  return (
    proxy?.principals
      ?.map((item: BasePrincipal) => {
        return item?.name && item?.inn && item?.kpp
          ? `${item?.name} ИНН: ${item?.inn} КПП: ${item?.kpp}`
          : '—'
      })
      .join(', ') || '—'
  )
}

export const getRepresentativesInns = (proxy: PoaItem): string => {
  return (
    proxy?.representatives
      ?.map((item: BasePerson) => {
        return item?.inn ? `${item?.inn}` : '—'
      })
      .join(', ') || '—'
  )
}

export const getRepresentativesNamesWithInn = (proxy: PoaItem): string => {
  return (
    proxy?.representatives
      ?.map((item: BasePerson) => {
        return (
          [item?.name, item?.surname, item?.middlename]
            .filter(Boolean)
            .join(' ') || '—'
        )
      })
      .join(', ') || '—'
  )
}

export const getPrincipalsOrganizationNamesWithInn = (
  proxy: PoaItem,
): string => {
  return (
    proxy?.principals
      ?.map((item: BasePrincipal) => {
        return item?.name && item?.inn
          ? `${item?.name} (ИНН: ${item?.inn})`
          : '—'
      })
      .join(', ') || '—'
  )
}
